import { Dialog, ListItem, styled } from '@mui/material';

export const StyledDialog = styled(Dialog)(() => ({}));

export const StyledListItem = styled(ListItem)(({ theme }) => ({
  backgroundColor: '#0380E8',
  color: '#FFFFFF',
  marginBottom: '0.8rem',
  borderRadius: theme.spacing(0.5),
  width: 'fit-content',
  textTransform: 'uppercase',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
    cursor: 'pointer',
  },
  '& span': {
    color: '#FFFFFF',
  },
}));

